import {ElementUtil} from '../../utils/elementUtil.js';
import {
	buildMigrationRunStepFields,
	loadMigrationStepOptions
} from './migrationStepOptions.js';
import {sortMigrationMessages} from './migrationStatusDialog.js';

export function showMigrationErrorDialog(record, migrationService, onRefresh) {
	var dialog = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'Error Recovery',
		icon: 'vaadin:exclamation-circle',
		width: .85,
		height: .8,
		listeners: {
			ready: function() {
				dialog.show();
				var summary = ElementUtil.create({
					tag: 'div',
					style: 'margin-bottom: 12px;',
					children: [
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>Failed step:</strong> ' + (record.lastFailedBatchStep || 'Unknown')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>V6:</strong> ' + (record.v6CompanyName || '')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>V8:</strong> ' + (record.companyName || '')}
					]
				});
				dialog.addToContentElement(summary);

				var errorGrid = ElementUtil.create({
					tag: 'vaadin-grid',
					theme: 'row-stripes column-borders',
					style: 'height: 300px; width: 100%;',
					defaults: {
						tag: 'vaadin-grid-sort-column',
						resizable: true
					},
					children: [
						{path: 'messageTypeDescription', header: 'Type', width: '110px', 'flex-grow': '0'},
						{path: 'batchStepName', header: 'Step', width: '180px', 'flex-grow': '0'},
						{path: 'entityTypeDescription', header: 'Entity', width: '150px', 'flex-grow': '0'},
						{path: 'v6EntityId', header: 'V6 Id', width: '120px', 'flex-grow': '0'},
						{path: 'message', header: 'Message', 'flex-grow': '1'}
					]
				});
				dialog.addToContentElement(errorGrid);

				var loadMask = errorGrid.showLoading();
				migrationService.getMigrationErrors(record.migrationId).then(function(errors) {
					errorGrid.items = sortMigrationMessages(errors.data || []);
				}).finally(function() {
					loadMask.remove();
				});

				var clearCheckpoints = ElementUtil.create({
					tag: 'vaadin-checkbox',
					label: 'Clear checkpoints and full re-pull',
					style: 'margin-top: 12px;'
				});
				dialog.addToContentElement(clearCheckpoints);

				var runStepFields = buildMigrationRunStepFields({
					migrationPhase: record.migrationPhase,
					defaultStep: record.lastFailedBatchStep || null
				});
				var runStepForm = ElementUtil.create({
					tag: 'vaadin-form-layout',
					style: 'margin-top: 12px;',
					children: runStepFields.fields
				});
				dialog.addToContentElement(runStepForm);
				loadMigrationStepOptions(migrationService).then(function(stepOptions) {
					runStepFields.bindStepOptions(stepOptions);
				});

				var buttonBar = ElementUtil.create({
					tag: 'div',
					style: 'margin-top: 16px; text-align: center;',
					defaults: {tag: 'vaadin-button'},
					children: [
						{
							theme: 'primary',
							children: [ElementUtil.makeIcon('vaadin:download', ' Download Full Log')],
							listeners: {
								click: function() {
									migrationService.downloadMigrationMessages(record.migrationId);
								}
							}
						},
						{
							theme: 'primary',
							style: 'margin-left: 10px;',
							children: [ElementUtil.makeIcon('vaadin:rotate-right', ' Re-run Step')],
							listeners: {
								click: function() {
									var message = clearCheckpoints.checked
										? 'Re-fetch all paged data from V6. Existing records will be updated via V6 id mapping, not duplicated.'
										: 'Resume from the last checkpoint.';
									window.DL.MessageUtil.showConfirm({
										title: 'Re-run Migration Step',
										message: message + '\n\nContinue?',
										buttons: [
											{text: 'Cancel'},
											{
												text: 'Re-run',
												theme: 'primary',
												handler: function() {
													var retryRequest = Object.assign({
														clearCheckpoints: clearCheckpoints.checked
													}, runStepFields.collectRunStepRequestData());
													migrationService.retryMigration(record.migrationId, retryRequest).then(function() {
														window.DL.MessageUtil.showToast('Success', 'Migration retry submitted', {theme: 'success'});
														dialog.close();
														if (onRefresh) {
															onRefresh();
														}
													});
												}
											}
										]
									});
								}
							}
						},
						{
							theme: 'tertiary error',
							style: 'margin-left: 10px;',
							innerHTML: 'Cancel Migration',
							listeners: {
								click: function() {
									migrationService.cancelMigration(record.migrationId).then(function() {
										window.DL.MessageUtil.showToast('Success', 'Migration canceled', {theme: 'success'});
										dialog.close();
										if (onRefresh) {
											onRefresh();
										}
									});
								}
							}
						},
						{
							theme: 'tertiary',
							style: 'margin-left: 10px;',
							innerHTML: 'Close',
							listeners: {
								click: function() {
									dialog.close();
								}
							}
						}
					]
				});
				dialog.addToContentElement(buttonBar);
			}
		}
	});
}
